import { mapGetters, mapActions } from 'vuex'

import utils from '../utilities/utils'
import Modal from '../components/Modal.vue'
import userState from '../states/user'

const accountPageMixins = {
  data() {
    return {
      termsModal: {
        show: false,
      },
      transferModal: {
        show: false,
      },
      alertData: '',
      // eslint-disable-next-line max-len
      badrequestText: `<div class="ui main text container"><div class="ui text container body-content"><div class="ui grid"><div class="column"><h1 class="ui header"></h1>${this.$t('ManageIdentity.SharedResources.ErrorText')}</div></div><div class="ui divider"></div><div class="ui grid"><div class="column"> </div></div></div></div>`,
      // eslint-disable-next-line max-len
      accountExistText: `<div class="ui main text container"><div class="ui text container body-content"><div class="ui grid"><div class="column"><h1 class="ui header"></h1>${this.$t('ManageIdentity.Controllers.AccountController.Error: Email already in use')}</div></div><div class="ui divider"></div><div class="ui grid"><div class="column"> </div></div></div></div>`,      // eslint-disable-next-line max-len
      // eslint-disable-next-line max-len
      unauthorizedText: `<div class="ui main text container"><div class="ui text container body-content"><div class="ui grid"><div class="column"><h1 class="ui header"></h1>${this.$t('ManageIdentity.SharedResources.ErrorText')}</div></div><div class="ui divider"></div><div class="ui grid"><div class="column"> </div></div></div></div>`,
      // eslint-disable-next-line max-len
      invalidText: `<div class="ui main text container"><div class="ui text container body-content"><div class="ui grid"><div class="column"><h1 class="ui header">${this.$t('ManageIdentity.SharedResources.StatusMessageWarning')}</h1>${this.$t('ManageIdentity.Controllers.AccountController.Invalidloginattempt')}</div></div><div class="ui divider"></div><div class="ui grid"><div class="column"> </div></div></div></div>`,
    }
  },
  components: { Modal },
  computed: {
    ...mapGetters({
      tnc: 'TermsAndConditions/tnc',
      data: 'TermsAndConditions/data',
      tncOrg: 'TermsAndConditions/tncOrg',
      dataOrg: 'TermsAndConditions/dataOrg',
      getConfig: 'ModuleConfig/moduleConfig',
    }),
  },
  methods: {
    ...mapActions({
      login: 'AuthV2/authRequest',
      loadEventInformation: 'ModuleConfig/loadEventInformation',
      loadTermsAndConditions: 'TermsAndConditions/loadTermsAndConditions',
      loadTermsAndConditionsOrg: 'TermsAndConditions/loadTermsAndConditionsOrg',
      prefillUser: 'AuthV2/getExternalUserData',
      confirmEmail: 'AuthV2/confirmationRequest',
      passwordRetrieval: 'AuthV2/passwordRequest',
      createAccount: 'AuthV2/accountRequest',
      transferAccount: 'AuthV2/transferRequest',
      changePassword: 'AuthV2/changePassword',
      changeEmail: 'AuthV2/changeEmail',
      ssoLoadConfiguration: 'singleSignOn/ssoLoadConfiguration',
      ssoEvaluateCurrentUser: 'singleSignOn/ssoEvaluateCurrentUser',
      ssoRegisterExternalAccount: 'singleSignOn/ssoRegisterExternalAccount',
      ssoAcceptTermsConditions: 'singleSignOn/ssoAcceptTermsAndConditions',
      ssoUserConfirmPassword: 'singleSignOn/ssoUserConfirmPassword',
      ssoExternalRegisterAccount: 'singleSignOn/ssoExternalRegisterAccount',
      loadExternalUserCompareData: 'singleSignOn/loadExternalUserCompareData',
      ssoExternalUserCompareData: 'singleSignOn/ssoExternalUserCompareData',
      ssoSyncExternalUser: 'singleSignOn/ssoSyncExternalUser',
      ssoSetTokenData: 'singleSignOn/ssoSetTokenData',
      // deleteHistory: 'instancesState/removeHistory',
    }),
    goToResetPage() {
      this.$router.push(utils.getRouteWithDefaultParams('PasswordRetrievalPage'))
    },
    goToLogin() {
      this.$router.push(utils.getRouteWithDefaultParams('LoginPage'))
    },
    goToCreatePage() {
      this.$router.push(utils.getRouteWithDefaultParams('CreateAccountPage'))
    },
    goToConfirmPage(params) {
      this.$router.push(utils.getRouteWithDefaultParams('ConfirmationPage', params))
    },
    goToAuthCorrelatePage(params) {
      this.$router.push(utils.getRouteWithDefaultParams('AuthCorrelate', params))
    },
    loginUser(token, oldToken, redirectUrl, redirectTimeout, redirectWithToken) {
      const returnUrl = this.getConfig.returnUrl != 'null' ? this.getConfig.returnUrl : '/'
      let timeout = redirectTimeout || 0
      if (redirectWithToken) {
        const urlParams = new URL(redirectUrl)
        const rUrl = new URL(urlParams.searchParams.get('target_redirect'))
        rUrl.searchParams.append('jwt_token', token)
        urlParams.searchParams.set('target_redirect', rUrl.toString())
        console.log('target_redirect', urlParams)
        window.location.href = urlParams
      } else if (!oldToken) {
        userState.setUser(this.getConfig.instance, {
          accessToken: token,
          validUntil: new Date().getTime() + (86400 * 1000), // 3600 = 1h,
        })
        setTimeout(() => {
          console.log('redirect timeout', redirectUrl)
          window.location.href = redirectUrl
        }, timeout)
      } else {
        const loginEvent = new CustomEvent('m-anage.login', {
          detail: {
            token: token,
            returnUrl
          }
        })
        window.dispatchEvent(loginEvent)
      }
    },
    isUrl(link) {
      if (!this.isString(link)) {
        return false
      }
      return link.startsWith('http')
    },
    isString(str) {
      return Object.prototype.toString.call(str) === '[object String]'
    },
  },

}

export default accountPageMixins
